import { Flex, FlexProps } from '@blockanalitica/ui';
import styled from 'styled-components';

const FirstSymbol = styled.div`
  z-index: 0;
`;

const SecondSymbol = styled.div`
  position: relative;
  left: -10%;
  z-index: 1;
`;

const ThirdSymbol = styled.div`
  position: relative;
  left: -20%;
  z-index: 1;
`;

const FourthSymbol = styled.div`
  position: relative;
  left: -30%;
  z-index: 1;
`;

const FifthSymbol = styled.div`
  position: relative;
  left: -40%;
  z-index: 1;
`;

export interface EntityNameProps extends FlexProps {
  symbol1?: React.ReactNode;
  symbol2?: React.ReactNode;
  symbol3?: React.ReactNode;
  symbol4?: React.ReactNode;
  symbol5?: React.ReactNode;
  children: React.ReactNode;
}

export default function EntityName({
  symbol1,
  symbol2,
  symbol3,
  symbol4,
  symbol5,
  children,
  ...rest
}: EntityNameProps) {
  return (
    <Flex alignItems="center" gap={symbol2 ? '3xs' : '2xs'} {...rest}>
      <Flex alignItems="center">
        {symbol1 ? <FirstSymbol>{symbol1}</FirstSymbol> : null}
        {symbol2 ? <SecondSymbol>{symbol2}</SecondSymbol> : null}
        {symbol3 ? <ThirdSymbol>{symbol3}</ThirdSymbol> : null}
        {symbol4 ? <FourthSymbol>{symbol4}</FourthSymbol> : null}
        {symbol5 ? <FifthSymbol>{symbol5}</FifthSymbol> : null}
      </Flex>
      {children}
    </Flex>
  );
}
